import {
    MIS_TEAM_LIST_SUCCESS,
    MIS_TEAM_LIST_FAILURE,
    FETCH_MIS_TEAM_BY_ID_SUCCESS,
    FETCH_MIS_TEAM_BY_ID_FAILURE,
    UPDATE_MIS_TEAM_FAILURE,
    UPDATE_MIS_TEAM_SUCCESS,
    FETCH_MIS_FIELDS_SUCCESS,
    FETCH_MIS_FIELDS_FAILURE,
    FETCH_DEFAULT_MIS_FIELDS_SUCCESS,
    FETCH_DEFAULT_MIS_FIELDS_FAILURE

} from './action';
const initialState = {
    misTeamListSuccess: [],
    misTeamListFailure: [],
    fetchMisTeamByIdSuccess: null,
    fetchMisTeamByIdFailure: null,
    updateMisTeamSuccess: null,
    updateMisTeamFailure: null,
    fetchDefaultMisFieldListSuccess: null,
    fetchDefaultMisFieldListFailure: null,
    fetchMisFieldListSuccess: null,
    fetchMisFieldListFailure: null,
}


const misTeamReducer = (state = initialState, action) => {
    switch (action.type) {
        case MIS_TEAM_LIST_SUCCESS:
            return state = {
                ...state,
                misTeamListSuccess: action.data
            }
        case MIS_TEAM_LIST_FAILURE:
            return state = {
                ...state,
                misTeamListFailure: action.data
            }
        case FETCH_MIS_TEAM_BY_ID_SUCCESS:
            return state = {
                ...state,
                fetchMisTeamByIdSuccess: action.data
            }
        case FETCH_MIS_TEAM_BY_ID_FAILURE:
            return state = {
                ...state,
                fetchMisTeamByIdFailure: action.data
            }
        case UPDATE_MIS_TEAM_FAILURE:
            return state = {
                ...state,
                updateMisTeamFailure: action.data
            }
        case UPDATE_MIS_TEAM_SUCCESS:
            return state = {
                ...state,
                updateMisTeamSuccess: action.data
            }
        case FETCH_MIS_FIELDS_SUCCESS:
            return state = {
                ...state,
                fetchMisFieldListSuccess: action.data
            }
        case FETCH_MIS_FIELDS_FAILURE:
            return state = {
                ...state,
                fetchMisFieldListFailure: action.error
            }

        case FETCH_DEFAULT_MIS_FIELDS_SUCCESS:
            return state = {
                ...state,
                fetchDefaultMisFieldListSuccess: action.data
            }

        case FETCH_DEFAULT_MIS_FIELDS_FAILURE:
            return state = {
                ...state,
                fetchDefaultMisFieldListFailure: action.error
            }
        default: return state
    }
}
export default misTeamReducer;